import { FieldConfigs } from "../shared/components/FormType";

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Mã vật tư, Tên vật tư",
};

export const MaterialTableColumns = [
    { key: "code", text: "Mã vật tư", icon: <></> },
    { key: "name", text: "Tên vật tư", icon: <></> },
    { key: "actual_quantity", text: "Tồn thực tế", icon: <></> },
    { key: "locked_quantity", text: "Đang khóa", icon: <></> },
    { key: "available_quantity", text: "Khả dụng", icon: <></> },
    { key: "warning", text: "Cảnh báo tồn kho", icon: <></> },
    { key: "storage", text: "Kho số", icon: <></> },
    { key: "measurement_unit", text: "Đơn vị chính", icon: <></> },
    { key: "secondary_measurement_unit", text: "Đơn vị phụ", icon: <></> },
    { key: "conversion_rate", text: "Tỉ lệ chuyển đổi", icon: <></> },
    { key: "note", text: "Ghi chú (Boxes)", icon: <></> },
    // { text: "Ngày hết hạn", icon: <></> },
];

export const CreateMaterialTitleBar = {
    title: "Tạo mới vật tư",
    cancelButton: "Huỷ bỏ",
    addButton: "Lưu vật tư",
    duplicateButton: "Nhân bản",
    deleteButton: "Xoá vật tư",
};

export const WarningMaterialModal = {
    title: "Huỷ bỏ",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const DeleteMaterialModal = {
    title: "Xoá vật tư",
    context:
        "Bạn có chắc chắn muốn xoá vật tư này không? Hành động này sẽ không được hoàn tác.",
};

export const materialCreateFields: FieldConfigs[] = [
    {
        label: "Trạng thái vật tư",
        type: "toggle",
        key: "is_active",
        required: true,
    },

    { label: "Mã vật tư", type: "text", key: "material_code", required: true },
    { label: "Tên vật tư", type: "text", key: "name", required: true },
    {
        label: "Mức cảnh báo tồn kho",
        type: "text",
        key: "threshold",
        required: false,
        validation: "number",
    },
    {
        label: "Nhóm vật tư",
        type: "quickFills",
        key: "category_group",
        required: true,
        dataApi: "/materials/category-groups/",
        placeholder: "Chọn nhóm vật tư",
    },
    {
        label: "Kho số",
        type: "dropdown",
        key: "storage",
        required: true,
        options: [
            { text: "Kho 1", value: "Kho 1" },
            { text: "Kho 2", value: "Kho 2" },
        ],
    },
    {
        label: "Hạng mục",
        type: "dropdown",
        key: "category",
        required: true,
        options: [
            { text: "Vật tư chính", value: "Vật tư chính" },
            { text: "Vật tư phụ", value: "Vật tư phụ" },
            { text: "Vật tư khác", value: "Vật tư khác" },
        ],
    },
    {
        label: "Đơn vị chính",
        type: "dropdown",
        key: "measurement_unit",
        required: false,
        options: [
            { text: "mét", value: "mét" },
            { text: "kg (kilogram)", value: "kg" },
            { text: "lít", value: "lít" },
            { text: "thùng", value: "thùng" },
            { text: "cái", value: "cái" },
            { text: "tấm", value: "tấm" },
            { text: "chai", value: "chai" },
            { text: "bộ", value: "bộ" },
            { text: "bịch", value: "bịch" },
            { text: "cuộn", value: "cuộn" },
            { text: "cây", value: "cây" },
            { text: "con", value: "con" },
            { text: "miếng", value: "miếng" },
            { text: "tờ", value: "tờ" },
            { text: "tuýt", value: "tuýt" },
            { text: "hộp", value: "hộp" },
        ],
    },
    {
        label: "Đơn vị phụ",
        type: "dropdown",
        key: "secondary_measurement_unit",
        required: false,
        options: [
            { text: "mét", value: "mét" },
            { text: "kg (kilogram)", value: "kg" },
            { text: "lít", value: "lít" },
            { text: "thùng", value: "thùng" },
            { text: "cái", value: "cái" },
            { text: "tấm", value: "tấm" },
            { text: "chai", value: "chai" },
            { text: "bộ", value: "bộ" },
            { text: "bịch", value: "bịch" },
            { text: "cuộn", value: "cuộn" },
            { text: "cây", value: "cây" },
            { text: "con", value: "con" },
            { text: "miếng", value: "miếng" },
            { text: "tờ", value: "tờ" },
            { text: "tuýt", value: "tuýt" },
            { text: "hộp", value: "hộp" },
        ],
    },
    // {
    //     label: "Ngày hết hạn",
    //     type: "calendar",
    //     key: "expired_date",
    //     required: false,
    // },
    { label: "Ghi chú (Boxes)", type: "text", key: "note", required: false },
];
